module.exports = __webpack_public_path__ + "img/1723687978946-keripik singkong.jpg.a173164d.webp";